import { DateTime } from 'luxon'

const englishLocales = ['en-US', 'en-GB', 'en-CA', 'en']

export function getTimeZoneAbbreviation(
  ianaTimeZone: string,
  date = DateTime.now(),
  locale = 'en-US',
): string {
  const zoneDateTime = date.setZone(ianaTimeZone)

  const localeArray = [locale, ...englishLocales]

  // Try multiple locales to increase chances of finding a proper abbreviation
  for (const loc of localeArray) {
    const abbr = zoneDateTime.toLocaleString(
      { timeZoneName: 'short' },
      { locale: loc },
    )

    const timeZonePart = abbr.split(' ').pop() ?? ''

    if (!timeZonePart.startsWith('GMT')) return timeZonePart
  }

  const abbreviation = zoneDateTime.toFormat('ZZZZ')

  // Use it if it's not a GMT format
  if (!abbreviation.startsWith('GMT')) return abbreviation

  // Fall back to the best we have
  return zoneDateTime.offsetNameShort || abbreviation
}
